import type { TransformedChatEntry } from '~services/api/bots/types';

export const sortChats = (chats: TransformedChatEntry[]) => {
	chats.sort((a, b) => {
		if (a.pinned && !b.pinned) return -1;
		if (!a.pinned && b.pinned) return 1;
		if (a.pinned && b.pinned) return 0;

		return (
			new Date(b.lastEventAt).getTime() - new Date(a.lastEventAt).getTime()
		);
	});
};
